import { combineReducers } from "redux";

function DashboardPagesReducer() {
  const allPages = (state = [], action) => {
    switch (action?.type) {
      case "GET_DASHBOARD_PAGES_INIT":
        return [];
      case "GET_DASHBOARD_PAGES_SUCCESS":
        return action?.payload;
      default:
        return state;
    }
  };

  const pageRights = (state = [], action) => {
    switch (action?.type) {
      case "GET_PAGE_RIGHTS_INIT":
        return [];
      case "GET_PAGE_RIGHTS_SUCCESS":
        return action?.payload;
      default:
        return state;
    }
  };

  const allObjects = (state = [], action) => {
    switch (action?.type) {
      case "GET_ALL_DASHBOARD_OBJECTS_INIT":
        return [];
      case "GET_ALL_DASHBOARD_OBJECTS_SUCCESS":
        return action?.payload;
      default:
        return state;
    }
  };

  const filters = (
    state = JSON.parse(localStorage.getItem("userDashboardFilters")) ?? [],
    action,
  ) => {
    switch (action?.type) {
      case "DASHBOARD_FILTERS_INIT":
        return [];
      case "UPDATE_DASHBOARD_FILTERS":
        return action?.payload;
      case "UPDATE_DASHBOARD_FILTER":
        return state?.length > 0
          ? state.map((item) => {
              if (action?.payload?.pageObjectId === item?.pageObjectId) {
                return { ...action?.payload };
              } else {
                return item;
              }
            })
          : [action.payload];
      default:
        return state;
    }
  };

  const objectsState = (state = [], action) => {
    switch (action?.type) {
      case "OBJECT_STATE_INIT":
        return [];
      case "UPDATE_OBJECT_STATE":
        return action?.payload;
      default:
        return state;
    }
  };

  return combineReducers({
    allPages,
    allObjects,
    pageRights,
    filters,
    objectsState,
  });
}

export default DashboardPagesReducer();
